export function convertVideoFrameToImageData(
  frame: HTMLVideoElement,
  canvas?: HTMLCanvasElement,
  ctx?: CanvasRenderingContext2D | null,
  targetWidth?: number,
  targetHeight?: number
): ImageData {
  const targetCanvas = canvas ?? document.createElement('canvas');
  const targetCtx = ctx ?? targetCanvas.getContext('2d');

  if (!targetCtx) {
    throw new Error('Failed to get 2D canvas context for video conversion.');
  }

  const nextWidth = targetWidth ?? frame.videoWidth;
  const nextHeight = targetHeight ?? frame.videoHeight;

  if (targetCanvas.width !== nextWidth) {
    targetCanvas.width = nextWidth;
  }
  if (targetCanvas.height !== nextHeight) {
    targetCanvas.height = nextHeight;
  }

  targetCtx.drawImage(frame, 0, 0, targetCanvas.width, targetCanvas.height);
  return targetCtx.getImageData(0, 0, targetCanvas.width, targetCanvas.height);
}
